/**
 * Entry point do React no browser. Também registra o service worker para
 * permitir instalação como PWA e abertura offline básica.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

function addHeadLink(rel: string, href: string, extra: Record<string, string> = {}): void {
  if (document.head.querySelector(`link[rel="${rel}"][href="${href}"]`)) return;
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  for (const [name, value] of Object.entries(extra)) link.setAttribute(name, value);
  document.head.appendChild(link);
}

// Os assets do PWA ficam em /public e são servidos na raiz. Injetar em runtime
// evita que o bundler do Bun tente resolver caminhos absolutos no HTML.
addHeadLink("manifest", "/manifest.webmanifest");
addHeadLink("icon", "/icons/icon-192.png", { type: "image/png" });
addHeadLink("apple-touch-icon", "/icons/apple-touch-icon.png");

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

(import.meta.hot.data.root ??= createRoot(elem)).render(app);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      // PWA ainda funciona sem service worker (ex: navegador sem suporte).
    });
  });
}
